import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { formatText } from '../../../helpers/value'
import { TITLE_TABLE_DOWNLOAD } from '../constant'
import { CustomTdActionDownloadedFiles } from './CustomTdActionDownloadedFiles'
import { CustomTdFormatFile } from './CustomTdFormatFile'

export const getSchemaTableDownloadedFiles = () =>
  TITLE_TABLE_DOWNLOAD.map((item, index) => {
    const result = {
      title: <Translate value={item.label} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
      },
    }
    if (index === 1) {
      return {
        ...result,
        render: (val) => {
          return <CustomTdFormatFile val={val} />
        },
      }
    }
    if (index === 3 || index === 4) {
      return {
        ...result,
        sortable: true,
        render: (val, { locale }) => {
          return formatDateTime(val, FORMAT.DATE, locale)
        },
      }
    }
    if (index === 5) {
      return {
        ...result,
        render: (val, { rowId }) => {
          return <CustomTdActionDownloadedFiles rowId={rowId} val={val} />
        },
      }
    }
    return {
      ...result,
      render: (val) => {
        return formatText(val)
      },
    }
  })
